import React from "react";
import { useOutletContext } from "react-router-dom";
import Portfolio from "./Component/Portfolio";
import type { PortfolioSiteData } from "../types/resume";
import Seo from "../components/Seo";

const PortfolioWrapper = () => {
    const { data } = useOutletContext<{ data: Partial<PortfolioSiteData> }>();
    if (!data.portfolio) {
        return null;
    }

    return (
      <>
        <Seo
          title="Portfolio — Projects by Efwan Rizaldi"
          description="Selected projects by Efwan Rizaldi: Web3, e-commerce, HRIS, and full-stack web applications built with React, TypeScript and Supabase."
          path="/portfolio"
        />
        <div className="min-h-screen">
            <Portfolio data={data.portfolio} />
        </div>
      </>
    );
};

export default PortfolioWrapper;
